module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-4_active-923b6971c5793ef26d834d8fc7a16bd0.svg";